const pipe = (value, ...funcArr) =>
    funcArr.reduce((before, after) => after ? after(before) : before, value);

export {
    pipe,
}